import { ADMSRDF } from '../const/C';
import settings from '../virtuoso/settings';
import ApiUtils from '../virtuoso/ApiUtils';
import LiferayApiUtils from '../liferay/ApiUtils';
import LiferaySettings from '../liferay/settings';
import { admsAssets, AdmsAssetsCountRequst, admsThemeTaxonomy, skosConceptInScheme, PredicatSubjectRequest,
    NewAssetInCatalogRequest, DeleteAssetInCatalogRequest, UnlinkAssetInCatalogRequest,
    RdfsLabelRequest, DeleteWikiInAssetRequest, DeleteDistributionInAssetRequest,
    NewWikiInAssetRequest, NewDistributionInAssetRequest, SkosConceptLinkCountRequest,
    RdfsLabelFirstCharCountRequest, DCTermsDescriptionRequest, AddPropertyInAssetRequest,
    RemovePropertyInAssetRequest, UpdateLiteralPropertyRequest, UpdateObjectPropertyRequest,
    NamedIndividualsRequest, DeleteLiteralValueInPropertyRequest, DeleteLinkValueInPropertyRequest } from '../virtuoso/request';
import { makeWhereFilter, makeWhereFilterAdv } from '../virtuoso/filter';
import { getCountValue2 } from '../virtuoso/helper';

/** Проверяет, что есть назначенный условия */
const isConditionPresent = (conditions, rfilter) => {
    return (Array.isArray(conditions) && conditions.length>0) || (Array.isArray(rfilter) && rfilter.length>0);
}
/** Формирует запрос с учётом наличия условий. Если условяи есть, то делается cloneOriginal() 
 * и добавляются условия! */
const makeRequest = (pattern, conditions, rfilter) => {
    if (!isConditionPresent(conditions, rfilter))
        return pattern;
    const request = pattern.cloneOriginal();
    makeWhereFilterAdv(request, [...conditions.map(a => ({...a})), ...rfilter.map(a => ({...a}))], true);
    return request;
}

/** Формирует последовательность таксономии */
const sortTaxonomy = taxonomy => {
    //Отсортируем sortTaxonomy = taxonomy => {", taxonomy);последовательности IRI в ADMSRDF.TAXONOMY_SEQUENCE
    console.log("AdmsActions.js sortTaxonomy", taxonomy, ADMSRDF.TAXONOMY_SEQUENCE)
    let j = 0;
    for (let i = 0; i < ADMSRDF.TAXONOMY_SEQUENCE.length; i++) {
        const IRI = ADMSRDF.TAXONOMY_SEQUENCE[i];
        const pos = taxonomy.map(item => item.IRI.value).indexOf(IRI);
        if (pos<0) continue;
        if (j==pos) {j++ ; continue};
        if (j>=(taxonomy.length-1)) break;
        [taxonomy[pos], taxonomy[j]] = [taxonomy[j], taxonomy[pos]];
        j++;
    }
    return taxonomy;
}
//Загрузка описание ADMS каталога (онтологии) и элементов ADMS каталога
export const AdmsRepository = {
    //Значение обязательного фильтра
    RFILTER: [],
    EMPTY: () => ({
        type: AdmsRepository.EMPTY,
    }),
    SET_RFILTER: rfilter => {
        AdmsRepository.RFILTER = rfilter;
        return ({
            type: AdmsRepository.SET_RFILTER, 
            rfilter
        })
    },
    LOAD_STARTED: () => ({
        type: AdmsRepository.LOAD_STARTED,
    }),
    LOAD_ERROR: (error) => ({
        type: AdmsRepository.LOAD_ERROR,
        error
    }),
    LOAD_DESCRIPTION: (IRI, description) => ({
        type: AdmsRepository.LOAD_DESCRIPTION,
        IRI, description
    }),
    LOAD_ASSETS: (offset, limit, count, head, distinct, ordered, assets) => ({
        type: AdmsRepository.LOAD_ASSETS,
        offset, limit, count, head, distinct, ordered, assets
    }),
    LOAD_NEXTASSETS: (offset, limit, head, distinct, ordered, assets) => ({
        type: AdmsRepository.LOAD_NEXTASSETS,
        offset, limit, head, distinct, ordered, assets
    }),
    LOAD_THEMETAXONOMY: taxonomy => ({
        type: AdmsRepository.LOAD_THEMETAXONOMY,
        taxonomy
    }),
    LOAD_TAXONOMY: (taxonomy, concepts, schema) => ({
        type: AdmsRepository.LOAD_TAXONOMY,
        taxonomy, concepts, schema
    }),
    STATISTICS: (IRI, statistic) => ({
        type: AdmsRepository.STATISTICS, IRI, statistic
    }),
    ADD_ASSET: (iri, label, lang) =>({
        type: AdmsRepository.ADD_ASSET,
        iri, label, lang
    }),
    REMOVE_ASSET: (iri) => ({
        type: AdmsRepository.REMOVE_ASSET,
        iri,
    }),
    CONDITIONS: conditions => ({
        type: AdmsRepository.CONDITIONS,
        conditions,
    }),
    /** Сохранить текущие настройки и выборанные элементы в стеке */
    PUSH : () => ({
        type: AdmsRepository.PUSH,
    }),

    /** Вернуть текущие настройки и выборанные элементы из стека */
    POP : () => ({
        type: AdmsRepository.POP,
    }),
    /** Загрузить информацию об ассетах в список. conditions - условия отбора,  
     * rfilter - обязательные условия отбора. При загрузке дополнительно загружается 
     * количество ассатов*/
    loadAssets: (conditions=[], rfilter=AdmsRepository.RFILTER) => dispatch => {
        dispatch(AdmsRepository.LOAD_STARTED());
        const options = {...settings.options};
        const request = makeRequest(admsAssets, conditions, rfilter);
        request.request.offset = 0;
        request.request.limit = settings.defaultLimit;
        console.log("loadAssets: (conditions=[], rfilter=[]) => dispatch => {", request);
        const counter = makeRequest(AdmsAssetsCountRequst, conditions, rfilter);
        return Promise.all([
                ApiUtils.query(request, {}, options),
                ApiUtils.query(counter, {}, options),
            ]).then ((response) =>{
                const {head, results} = response[0];
                const {distinct, ordered, bindings} = results;
                const count = getCountValue2(response[1].results.bindings, -1);
                dispatch(AdmsRepository.LOAD_ASSETS(0, request.request.limit, count, head, distinct, ordered, bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(AdmsRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Загрузить следующую порцию информации об ассетах */
    loadNextAssets: (offset, conditions=[], rfilter=AdmsRepository.RFILTER) => dispatch => {
        dispatch(AdmsRepository.LOAD_STARTED());
        const options = {...settings.options};
        const request = makeRequest(admsAssets, conditions, rfilter);
        request.request.offset = offset;
        request.request.limit = settings.defaultLimit;
        return ApiUtils.query(request, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(AdmsRepository.LOAD_NEXTASSETS(offset, request.request.limit, head, distinct, ordered, bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(AdmsRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },


    /** Загрузить информацию о таксономии каталога. Является вспомогательной частью описания каталога.
     * Отслеживать процесс загрузки нет необходимости, так как требуется только для фильтрации в UI. */
    loadThemeTaxonomy: () => dispatch => {
        const options = {...settings.options};
        return ApiUtils.query(admsThemeTaxonomy, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(AdmsRepository.LOAD_THEMETAXONOMY(sortTaxonomy(bindings)));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(AdmsRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Загрузка концептов, входящих в схему. */
    loadTaxonomy: taxonomy => dispatch => {
        const options = {...settings.options};
        skosConceptInScheme.setConceptScheme(taxonomy);
        RdfsLabelRequest.setURI(taxonomy);
        return Promise.all([
                ApiUtils.query(skosConceptInScheme, {}, options),
                ApiUtils.query(RdfsLabelRequest, {}, options),
            ]) .then ((response) =>{
                const {head, results} = response[0];
                const {distinct, ordered, bindings} = results;
                dispatch(AdmsRepository.LOAD_TAXONOMY(taxonomy, bindings, response[1].results.bindings));
                return Promise.resolve({taxonomy, response});
            })
            .catch(e => { 
                dispatch(AdmsRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Загрузка количества доступных элементов по таксономии. Заполняет vadms.statistics */
    loadTaxonomyConceptCount: (conceptIRI, lang, graph, rfilter=AdmsRepository.RFILTER, conditions=[]) => dispatch => {
        const options = {...settings.options};
        const request = (isConditionPresent(conditions, rfilter))? SkosConceptLinkCountRequest.cloneOriginal():SkosConceptLinkCountRequest;
        request.setConceptIRI(conceptIRI);
        if (isConditionPresent(conditions, rfilter))
            makeWhereFilterAdv(request, [...conditions.map(a => ({...a})), ...rfilter.map(a => ({...a}))], true);
        //console.log("loadTaxonomyConceptCount: conceptIRI => dispatch => { SkosConceptLinkCountRequest", SkosConceptLinkCountRequest.request);
        return ApiUtils.query(request, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                const count =(Array.isArray(bindings) && (bindings.length>0))?bindings[0].cnt.value: 0;
                //Пример ответа { "head": { "link": [], "vars": ["theme", "cnt"] },
                // "results": { "distinct": false, "ordered": true, "bindings": [
                //      { "theme": { "type": "uri", "value": "http://hbz.ru/adms/internal" }, "cnt": { "type": "typed-literal", "datatype": "http://www.w3.org/2001/XMLSchema#integer", "value": "7" }} ] } }
                dispatch(AdmsRepository.STATISTICS(conceptIRI, {count}));
                return Promise.resolve({conceptIRI, count, response});
            })
            .catch(e => { 
                dispatch(AdmsRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Загрузка количества доступных элементов по таксономии. Заполняет vadms.statistics */
    loadFirstCharCount: (lang, graph, rfilter=AdmsRepository.RFILTER, conditions=[]) => dispatch => {
        const options = {...settings.options};
        const request = (isConditionPresent(conditions, rfilter))? RdfsLabelFirstCharCountRequest.cloneOriginal():RdfsLabelFirstCharCountRequest;
        //Убераем добавления фильтра, так как алфавит работает схеме ИЛИ, т.е. нужно всега знать все доступные буквы
        // if (isConditionPresent(conditions, rfilter))
        //     makeWhereFilterAdv(request, [...conditions.map(a => ({...a})), ...rfilter.map(a => ({...a}))], true);
        return ApiUtils.query(request, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                //Пример ответа { "head": { "link": [], "vars": ["firstlitera", "cnt"] },
                //"results": { "distinct": false, "ordered": true, "bindings": [
                //  { "firstlitera": { "type": "literal", "value": "F" }	, "cnt": { "type": "typed-literal", "datatype": "http://www.w3.org/2001/XMLSchema#integer", "value": "1" }},
                //  { "firstlitera": { "type": "literal", "value": "\u0422" }	, "cnt": { "type": "typed-literal", "datatype": "http://www.w3.org/2001/XMLSchema#integer", "value": "1" }} ] } }
                const chars = {};
                bindings.map(item => chars[item["firstlitera"].value]=item["cnt"].value);
                dispatch(AdmsRepository.STATISTICS("http://www.w3.org/2000/01/rdf-schema#label", {chars}));
                return Promise.resolve({IRI:"http://www.w3.org/2000/01/rdf-schema#label", chars, response});
            })
            .catch(e => { 
                dispatch(AdmsRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Добавление нового элемента. Для добавления используется прокси сервис в Liferay */
    addElement: (catalog, iri, type, label, lang) => dispatch => {
        NewAssetInCatalogRequest.setValues(catalog, iri, label, lang);
        //const options = {...settings.options};
        //console.log("NewAssetInCatalogRequest",NewAssetInCatalogRequest.request);
        const options = {...LiferaySettings.options};
        const formData = {
          'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
          'default_graph_uri': NewAssetInCatalogRequest.graph,
          'query': NewAssetInCatalogRequest.sparql,
        }
        //console.log("AdmsActions.js addElement", formData, options);
        return LiferayApiUtils.postToLifeRay721(formData, options)
          .then ((response) =>{
                dispatch(AdmsRepository.ADD_ASSET(iri, label, lang));
                return Promise.resolve({iri, type, label, lang, response});
          })
          .catch(e => { 
                dispatch(AdmsRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
          });
    
        // return ApiUtils.query(NewAssetInCatalogRequest, {}, options)
        //     .then ((response) =>{
        //         dispatch(AdmsRepository.ADD_ASSET(iri, label, lang));
        //         return Promise.resolve({iri, type, label, lang, response});
        //     })
        //     .catch(e => { 
        //         dispatch(AdmsRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
        //         return Promise.reject(e);
        //     });
    },

    /** Добавление нового элемента. Для добавления используется прокси сервис в Liferay */
    deleteElement: (catalog, iri) => dispatch => {
        DeleteAssetInCatalogRequest.setCatalog(catalog);
        DeleteAssetInCatalogRequest.setIRI(iri);
        //const options = {...settings.options};
        //console.log("DeleteAssetInCatalogRequest",DeleteAssetInCatalogRequest.request);
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': DeleteAssetInCatalogRequest.graph,
            'query': DeleteAssetInCatalogRequest.sparql,
          }
        console.log("AdmsActions.js deleteElement", formData, options);
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                dispatch(AdmsRepository.REMOVE_ASSET(iri));
                return Promise.resolve({iri, response});
            })
            .catch(e => { 
                dispatch(AdmsRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });

        //   return ApiUtils.query(DeleteAssetInCatalogRequest, {}, options)
        //     .then ((response) =>{
        //         dispatch(AdmsRepository.REMOVE_ASSET(iri));
        //         return Promise.resolve({iri, response});
        //     })
        //     .catch(e => { 
        //         dispatch(AdmsRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
        //         return Promise.reject(e);
        //     });
    },

    /** Добавление нового элемента. Для добавления используется прокси сервис в Liferay */
    unlinkElement: (catalog, iri) => dispatch => {
        UnlinkAssetInCatalogRequest.setCatalog(catalog);
        UnlinkAssetInCatalogRequest.setIRI(iri);
        //const options = {...settings.options};
        //console.log("UnlinkAssetInCatalogRequest",UnlinkAssetInCatalogRequest.request);
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': UnlinkAssetInCatalogRequest.graph,
            'query': UnlinkAssetInCatalogRequest.sparql,
          }
        console.log("AdmsActions.js unlinkElement", formData, options);
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                dispatch(AdmsRepository.REMOVE_ASSET(iri));
                return Promise.resolve({iri, response});
            })
            .catch(e => { 
                dispatch(AdmsRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });

        // return ApiUtils.query(UnlinkAssetInCatalogRequest, {}, options)
        //     .then ((response) =>{
        //         dispatch(AdmsRepository.REMOVE_ASSET(iri));
        //         return Promise.resolve({iri, response});
        //     })
        //     .catch(e => { 
        //         dispatch(AdmsRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
        //         return Promise.reject(e);
        //     });
    },

    /** Загрузить информацию об описаниии актива. Значение для предиката http://purl.org/dc/terms/description  */
    loadDescription: (iri) => dispatch => {
        const options = {...settings.options};
        DCTermsDescriptionRequest.setURI(iri);
        return ApiUtils.query(DCTermsDescriptionRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(AdmsRepository.LOAD_DESCRIPTION(iri, bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(AdmsRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

};

export const AdmsAsset = {
    EMPTY: () => ({
        type: AdmsAsset.EMPTY,
    }),
    LOAD_STARTED: () => ({
        type: AdmsAsset.LOAD_STARTED,
    }),
    LOAD_ERROR: (error) => ({
        type: AdmsAsset.LOAD_ERROR,
        error
    }),
    LOAD_ASSET: (iri, head, values) => ({
        type: AdmsAsset.LOAD_ASSET,
        iri, values, head,
        predicates : (values && Array.isArray(values))?[...new Set(values.map(item => item.predicat.value))]:[], 
        languages: (values && Array.isArray(values))?[...new Set(values.map(item => item.object["xml:lang"]))]:[], 
        distributions: (values && Array.isArray(values))? values.filter(item => item.predicat.value== ADMSRDF.PREDICAT_DISTRIBUTION):[], 
        wikies: (values && Array.isArray(values))? values.filter(item => item.predicat.value== ADMSRDF.PREDICAT_WIKI):[], 
    }),
    LOAD_LABELBYIRI: (iri, head, values) => ({
        type: AdmsAsset.LOAD_LABELBYIRI,
        iri, values, head,
    }),

    LOAD_DISTRIBUTIONS: distributions => ({
        type: AdmsAsset.LOAD_DISTRIBUTIONS, distributions
    }),

    LOAD_WIKIES: wikies => ({
        type: AdmsAsset.LOAD_WIKIES, wikies
    }),

    LOAD_DETAIL: (triplet, head, values, state) => ({
        type: AdmsAsset.LOAD_DETAIL,
        triplet, head, values, state,
    }),

    REMOVE_DISTRIBUTION: (iri) => ({
        type: AdmsAsset.REMOVE_DISTRIBUTION,
        iri,
    }),

    ADD_DISTRIBUTION: (iri, distribution) => ({
        type: AdmsAsset.ADD_DISTRIBUTION,
        iri, distribution
    }),

    REMOVE_WIKI: (iri) => ({
        type: AdmsAsset.REMOVE_WIKI,
        iri,
    }),

    ADD_WIKI: (iri, wiki) => ({
        type: AdmsAsset.ADD_WIKI,
        iri, wiki
    }),

    /** Загрузить информацию ассетах */
    loadAsset: (iri) => dispatch => {
        dispatch(AdmsAsset.LOAD_STARTED());
        const options = {...settings.options};
        //console.log("11111", PredicatSubjectRequest.request);
        PredicatSubjectRequest.setIRI(iri);
        return ApiUtils.query(PredicatSubjectRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(AdmsAsset.LOAD_ASSET(iri, head, bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(AdmsAsset.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    loadSelected: (iri) => dispatch => {
        return dispatch(AdmsAsset.loadAsset(iri));
    },

    // Загрузить информацию о метках 
    loadLabelByIRI: (IRI) => dispatch => {
        const options = {...settings.options};
        RdfsLabelRequest.setURI(IRI);
        return ApiUtils.query(RdfsLabelRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(AdmsAsset.LOAD_LABELBYIRI(IRI, head, bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(AdmsAsset.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Получение детальной информации о триплете */
    onDetailElement: (triplet) => dispatch => {
        const options = {...settings.options};
        PredicatSubjectRequest.setIRI(triplet.object.value);
        return ApiUtils.query(PredicatSubjectRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(AdmsAsset.LOAD_DETAIL(triplet, head, bindings, "loaded"));
                return Promise.resolve({triplet, head, distinct, ordered, bindings});
            })
            .catch(e => { 
                dispatch(AdmsAsset.LOAD_DETAIL(triplet, [], [], "error"));
                return Promise.reject(e);
            });
    },

    deleteDistribution: (asset, distribution) => dispatch => {
        const options = {...settings.options};
        DeleteDistributionInAssetRequest.setAsset(asset);
        DeleteDistributionInAssetRequest.setIRI(distribution);        
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': DeleteDistributionInAssetRequest.graph,
            'query': DeleteDistributionInAssetRequest.sparql,
          }
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                dispatch(AdmsAsset.REMOVE_DISTRIBUTION(distribution));
                return Promise.resolve({distribution, response});
            })
            .catch(e => { 
                dispatch(AdmsAsset.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    deleteWiki: (asset, wiki) => dispatch => {
        const options = {...settings.options};
        DeleteWikiInAssetRequest.setAsset(asset);
        DeleteWikiInAssetRequest.setIRI(wiki);
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': DeleteWikiInAssetRequest.graph,
            'query': DeleteWikiInAssetRequest.sparql,
          }
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                dispatch(AdmsAsset.REMOVE_WIKI(wiki));
                return Promise.resolve({wiki, response});
            })
            .catch(e => { 
                dispatch(AdmsAsset.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    addWiki: (asset, iri, title, description, url, lang) => dispatch => {
        const options = {...settings.options};
        NewWikiInAssetRequest.setAsset(asset);
        NewWikiInAssetRequest.setValues(iri, title, description, url, lang);
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': NewWikiInAssetRequest.graph,
            'query': NewWikiInAssetRequest.sparql,
          }
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                //console.log("addWiki", asset, iri, title, description, url, lang, response);
                dispatch(AdmsAsset.ADD_WIKI(iri, response));
                return Promise.resolve({iri, response});
            })
            .catch(e => { 
                dispatch(AdmsAsset.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    addDistribution: (asset, iri, title, description, url, lang) => dispatch => {
        const options = {...settings.options};
        NewDistributionInAssetRequest.setAsset(asset);
        NewDistributionInAssetRequest.setValues(iri, title, description, url, lang);
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': NewDistributionInAssetRequest.graph,
            'query': NewDistributionInAssetRequest.sparql,
          }
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                //console.log("addDistribution", asset, iri, title, description, url, lang, NewDistributionInAssetRequest.request, response);
                dispatch(AdmsAsset.ADD_DISTRIBUTION(iri, response));
                return Promise.resolve({iri, response});
            })
            .catch(e => { 
                dispatch(AdmsAsset.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    addProperty: (IRI, predicat, lang) => dispatch => {
        AddPropertyInAssetRequest.setValues(IRI, predicat);
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': AddPropertyInAssetRequest.graph,
            'query': AddPropertyInAssetRequest.sparql,
          }
        //console.log("AdmsActions.js addProperty", IRI, predicat, lang, AddPropertyInAssetRequest);
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                //console.log("AdmsActions.js addProperty", IRI, predicat, lang, AddPropertyInAssetRequest.request, response);
                //dispatch(AdmsAsset.ADD_DISTRIBUTION(iri, response));
                return Promise.resolve({IRI, response});
            })
            .catch(e => { 
                dispatch(AdmsAsset.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    removeProperty: (IRI, predicat) => dispatch => {
        //console.log("AdmsActions.js removeProperty", IRI, predicat, RemovePropertyInAssetRequest);
        RemovePropertyInAssetRequest.setValues(IRI, predicat);
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': RemovePropertyInAssetRequest.graph,
            'query': RemovePropertyInAssetRequest.sparql,
          }
        //console.log("AdmsActions.js removeProperty", IRI, predicat, RemovePropertyInAssetRequest);
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                return Promise.resolve({iri, response});
            })
            .catch(e => { 
                dispatch(AdmsAsset.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    updateLiteralProperty: (IRI, predicat, oldValue, newValue, lang) => dispatch => {
        //console.log("AdmsActions.js updateLiterlProperty", IRI, predicat, oldValue, newValue, lang, UpdateLiteralPropertyRequest);
        UpdateLiteralPropertyRequest.setValues(IRI, predicat, oldValue, newValue, lang);
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': UpdateLiteralPropertyRequest.graph,
            'query': UpdateLiteralPropertyRequest.sparql,
          }
        //console.log("AdmsActions.js updateLiterlProperty", UpdateLiteralPropertyRequest);
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                return Promise.resolve({iri, response});
            })
            .catch(e => { 
                dispatch(AdmsAsset.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
        //return Promise.reject(e);
    },

    updateObjectProperty: (IRI, predicat, oldValue, newValue) => dispatch => {
        console.log("AdmsActions.js updateObjectProperty", IRI, predicat, oldValue, newValue, UpdateObjectPropertyRequest);
        UpdateObjectPropertyRequest.setValues(IRI, predicat, oldValue, newValue);
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': UpdateObjectPropertyRequest.graph,
            'query': UpdateObjectPropertyRequest.sparql,
          }
        console.log("AdmsActions.js updateLiterlProperty", UpdateObjectPropertyRequest);
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                return Promise.resolve({iri, response});
            })
            .catch(e => { 
                dispatch(AdmsAsset.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
        //return Promise.reject(e);
    },
 
    /** Загрузить информацию об индивидуалах. rdfType - IRI типf */
    loadNamedIndividuals: (rdfType, graph) => {
        const options = {...settings.options};
        NamedIndividualsRequest.setType(rdfType);
        return ApiUtils.query(NamedIndividualsRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                return Promise.resolve({rdfType, head, distinct, ordered, bindings});
            })
            .catch(e => { 
                return Promise.reject(e);
            });
    }, 

    deleteValueInProperty: (IRI, predicat, value) => dispatch => {
        const request = (value && value.startsWith("http")) ? DeleteLinkValueInPropertyRequest:DeleteLiteralValueInPropertyRequest;
        //console.log("AdmsActions.js deleteValueInObjectProperty", IRI, predicat,value, request);
        request.setValues(IRI, predicat, value);
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': request.graph,
            'query': request.sparql,
          }
        console.log("AdmsActions.js updateLiterlProperty", request);
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                return Promise.resolve({iri, response});
            })
            .catch(e => { 
                dispatch(AdmsAsset.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
        //return Promise.reject(e);
    },

}